<template>
  <div class="activity-box">
    <div class="main">
      <img class="bg" src="./images/bg.png" alt="" />
      <img class="avatar-frame1" src="./images/1.webp" alt="" />
      <img class="avatar-frame2" src="./images/2.webp" alt="" />

      <my-tags></my-tags>
    </div>
  </div>
</template>
<script>
import myTags from './my-tags.vue';
export default {
  components: { myTags },
  name: 'GreenValentineDay',
  data() {
    return {};
  },
  created() {}
};
</script>
<style lang="scss" scoped>
.activity-box {
  width: 100%;
  background-color: #e8f4de;
  overflow: auto;
  text-align: center;
  .main {
    position: relative;
    display: inline-block;
    width: 980px;
    text-align: left;
    .avatar-frame1,
    .avatar-frame2 {
      height: auto;
      position: absolute;
    }
    .avatar-frame1 {
      width: 180px;
      left: 213px;
      top: 898px;
    }
    .avatar-frame2 {
      width: 184px;
      left: 579px;
      top: 892px;
    }
    > .bg {
      width: 100%;
    }
    /deep/ .my-tags {
      position: absolute;
      z-index: 1;
      top: 1418px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
</style>
